import {
  Service,
  ServiceType,
} from '@wix/ambassador-bookings-services-v2-service/types';

export const isCourseService = (service: Service) => {
  return service.type === ServiceType.COURSE;
};
